import { KeyboardEventHandler } from "react";

import Box from "ds/components/Box";
import Counter from "ds/components/Counter";
import Input from "ds/components/Input";
import ButtonIcon from "ds/components/ButtonIcon";
import { ArrowDown, ArrowUp, Cross } from "components/icons/generated";
import Typography from "ds/components/Typography";

import styles from "./styles.module.css";

type SearchBarProps = {
  searchPhrase: string;
  searchOccurrences: { lineIndex: number; occurrenceIndex: number }[];
  currentOccurrenceIndex: number | undefined;
  onSearchPhraseChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onPreviousPress: () => void;
  onNextPress: () => void;
  onClose: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLInputElement>;
};

const ThemedLogsSearchBar = ({
  searchPhrase,
  searchOccurrences,
  currentOccurrenceIndex,
  onSearchPhraseChange,
  onPreviousPress,
  onNextPress,
  onClose,
  onKeyDown,
}: SearchBarProps) => {
  return (
    <Box className={styles.input} padding="x-large" justify="between">
      <Box gap="medium" align="center" grow="1">
        <Input
          onChange={onSearchPhraseChange}
          value={searchPhrase}
          placeholder="Search logs"
          className={styles.searchInput}
          onKeyDown={onKeyDown}
          autoFocus
        />
        <ButtonIcon
          variant="secondary"
          icon={ArrowUp}
          onPress={onPreviousPress}
          size="small"
          disabled={searchOccurrences.length === 0}
        >
          Previous result
        </ButtonIcon>
        <ButtonIcon
          variant="secondary"
          icon={ArrowDown}
          onPress={onNextPress}
          size="small"
          disabled={searchOccurrences.length === 0}
        >
          Next result
        </ButtonIcon>
        <Box>
          <Typography variant="p-body3" tag="div" color="primary" className={styles.searchResult}>
            Found <Counter count={searchOccurrences.length} className={styles.counter} /> results
            {currentOccurrenceIndex !== undefined &&
              ` (${currentOccurrenceIndex + 1}/${searchOccurrences.length})`}
          </Typography>
        </Box>
      </Box>
      <ButtonIcon variant="secondary" icon={Cross} onPress={onClose} size="small">
        Close
      </ButtonIcon>
    </Box>
  );
};

export default ThemedLogsSearchBar;
